<template>
  <main class="personal-data">
    <h1>{{$t(title)}}</h1>
    <div class="personal-data__container" id="accordion">
      <div class="personal-data__left-content">
        <router-link to="/messages/inbox" active-class="personal-data__btn__active" class="gui-btn personal-data__btn personal-data__btn--none-after">
          {{$t('messages.inbox')}}  <span class="personal-data__number-category">{{messages.notRead}}</span>
        </router-link>
        <router-link to="/messages/sent" active-class="personal-data__btn__active" class="gui-btn personal-data__btn personal-data__btn--none-after">
          {{$t('messages.sent')}}  <span class="personal-data__number-category">{{messages.sent}}</span>
        </router-link>
        <router-link to="/messages/trash" active-class="personal-data__btn__active" class="gui-btn personal-data__btn personal-data__btn--none-after">
          {{$t('messages.trash')}} <span class="personal-data__number-category">{{messages.deleted}}</span>
        </router-link>
        <router-link to="/messages/options/messages" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'messages.configure-messages'"/>
        <router-link to="/messages/options/subscriptions" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'messages.configure-subscriptions'"/>
      </div>
      <div class="personal-data__right-content">
        <router-view></router-view>
      </div>

      <!--Отображение preload Доп class preload-active -->
      <div class="toggle-preload ">
        <img src="@/assets/img/static/rolling.gif" alt="">
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    name: 'personal-data-page',

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions;
      },
      messages() {
        return this.$store.getters.currentUser.messages;
      },
      title() {
        return this.$route.meta.title;
      }
    }
  }
</script>

<style scoped>

</style>
